<div class="match-filter">
  <nav class="match-filter__pills" [attr.aria-label]="'filters.navLabel' | translate">
    @for (filter of filters(); track trackFilter($index, filter)) {
      <button
        type="button"
        class="sb-pill-button"
        [class.sb-pill-button--active]="filter.id === activeFilter()"
        [attr.aria-pressed]="filter.id === activeFilter()"
        (click)="filterChange.emit(filter.id)"
      >
        <span>{{ filter.labelKey ? (filter.labelKey | translate) : filter.label }}</span>
        @if (filter.count !== undefined) {
          <span class="match-filter__count">{{ filter.count }}</span>
        }
        @if (filter.showLiveDot) {
          <span class="match-filter__live-dot" aria-hidden="true"></span>
        }
      </button>
    }
  </nav>

  @if (searchVisible()) {
    <app-match-search
      class="match-filter__search"
      [expanded]="searchExpanded()"
      [query]="searchQuery()"
      (toggleExpanded)="searchToggle.emit()"
      (queryChange)="searchChange.emit($event)"
    ></app-match-search>
  }
</div>
